export default "__VITE_ASSET__B84Zeg8L__"